import React from "react";
import { generateCRUDRoutes } from "../../../utils/index";

import { FaHandHoldingHand } from "react-icons/fa6";
import TrainingModuleRequest from "./index";
import ViewTrainingModuleRequest from "./view";
import EditTrainingModuleRequest from "./edit";
import { MODULE_TRAINING_REQ } from "variables/constants";

const trainingModuleRequestsRoutes = [	
	generateCRUDRoutes({
		mainTitle: "Requests",
		basePath: "training-module-requests",
		mainComponent: <TrainingModuleRequest />,
	    layout: "/console",	   
	    icon: <FaHandHoldingHand className="icon-item" />,
	    subTitle:"Training Module Request",
	    viewComponent: <ViewTrainingModuleRequest />,
	    createComponent: <EditTrainingModuleRequest />,
	    editComponent: <EditTrainingModuleRequest />,
		level:5,
		moduleId: MODULE_TRAINING_REQ,
	})
]

export default trainingModuleRequestsRoutes;